import { render, staticRenderFns } from "./value-card-edit.vue?vue&type=template&id=cdca1c12&scoped=true&"
import script from "./value-card-edit.vue?vue&type=script&lang=ts&"
export * from "./value-card-edit.vue?vue&type=script&lang=ts&"
import style0 from "./value-card-edit.vue?vue&type=style&index=0&id=cdca1c12&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdca1c12",
  null
  
)

export default component.exports